import { render, staticRenderFns } from "./LoginComponentMessage.vue?vue&type=template&id=316446a3"
import script from "./LoginComponentMessage.vue?vue&type=script&lang=ts"
export * from "./LoginComponentMessage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports